var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import StyledProgressBar from '../../styles/elements/ProgressBar';
const ProgressBar = props => {
    const { customStyle, totalStep, currentStep } = props, rest = __rest(props, ["customStyle", "totalStep", "currentStep"]);
    return (<StyledProgressBar customStyle={customStyle} dataSet={{ 'brighte-class': 'brighte-progress' }} totalStep={totalStep} currentStep={currentStep} {...rest}/>);
};
ProgressBar.defaultProps = {
    customStyle: {},
    currentStep: 0,
};
export default ProgressBar;
